import * as React from 'react';

import { ANIMATION_DURATION } from './config';

export const useAnimateUnmount = (
  timeout: number = ANIMATION_DURATION.unmount
) => {
  const timeoutRef = React.useRef<NodeJS.Timeout>();
  const [isUnmount, setIsUnmount] = React.useState(false);

  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const animateUnmount = React.useCallback(
    (
        fn: () => void,
        callbacks?: {
          beforeTransition?: () => void;
        }
      ) =>
      () => {
        callbacks?.beforeTransition?.();

        setIsUnmount(true);
        timeoutRef.current = setTimeout(fn, timeout);
      },
    [timeout]
  );

  return [isUnmount, animateUnmount] as const;
};
